module.exports = __webpack_public_path__ + "img/Gasmachine1.0d1f075b.png";